export const approvalStatuses = {
  10: "Pending User",
  15: "Disable",
  20: "Approved",
  30: "Rejected User",
  40: "Incomplete Registration",
  25: "Update Profile",
};

export const UserApprovalEnum = {
  PENDING: 10,
  UNKNOWN: 15,
  APPROVED: 20,
  REJECTED: 30,
  REGISTERED: 40,
  UPDATE: 25,
};

export const reasons = [
  "Hi there! Having a complete profile helps you connect better with others. Please complete your bio and add real images which clearly show your face.",
  "Hi there! Having a complete profile helps you connect better with others. Please complete your bio.",
  "Hi there! Having a complete profile helps you connect better with others. Please add real images which clearly show your face.",
  "Hi there! It's best to keep your conversation to MTD until you create a connection. Please remove your contact details from your profile's written bio (phone, social etc).",
];

export const questionsDefaultAnswers = [
  "I invented mutton rolls. I've visited 5 countries. I can speak 2 languages.",
  "Drove 12 hours to New York just to eat some amazing pizza.",
  "I’d buy my amma her dream home.",
  "Laugh at my bad jokes.",
  "I’m free spirited, curious about people and places and always up for a new challenge!",
  "Family time, working out and trying out a new recipe in the kitchen. Cheesy kotthu roti anyone?",
  "“And when you want something, all the universe conspires in helping you achieve it”",
  "Values family, loves Tamil films and music as much as I do and is looking for something serious.",
  "To visit every country in the world!",
  "Meeting my grandparents for the first time back home!",
  "Grabbing a coffee and walking around the city!",
];
